"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZoomInIcon = void 0;
const react_1 = __importDefault(require("react"));
const colors_1 = require("../../../../../../../assets/styles/colors");
const ZoomInIcon = ({ color }) => (react_1.default.createElement("svg", { width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-label": "Zoom in" },
    react_1.default.createElement("path", { d: "M19 19L13.8033 13.8033M13.8033 13.8033C15.1605 12.4461 16 10.5711 16 8.5C16 4.35786 12.6421 1 8.5 1C4.35786 1 1 4.35786 1 8.5C1 12.6421 4.35786 16 8.5 16C10.5711 16 12.4461 15.1605 13.8033 13.8033ZM8.5 5.5V11.5M11.5 8.5H5.5", stroke: color ? `${color}` : `${colors_1.gray400}`, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })));
exports.ZoomInIcon = ZoomInIcon;
